import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CurrentUser } from "../providers/current-user";
import { AnnualPlan } from "../models/annual-plan";
import { User } from "../models/user";

@Injectable({
  providedIn: 'root'
})
export class CurrentUserResolver implements Resolve<AnnualPlan> {
    constructor(
        private currentUser: CurrentUser,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<any> {
        return new Promise<User>((resolve, reject) => resolve((this.currentUser.user!)));
    }
}
